<form [formGroup]="billingForm" (keydown.space)="validateEmpty($event)">
  <app-loader  *ngIf="loading"></app-loader>
    <div class="d-flex flex-column page_container">
        <div class="row flex-grow-1 pb-2 pb-3 pb-md-5">
            <div class="col-lg-6 col-md-8 col-sm-12 offset-lg-1 offset-md-1">
                <h1 class="app_page-title">Insurance coverage and billing</h1>
                <p>Which payment option would work best for clinic participants? If you're unsure now, mark "I don't know" below, and we'll help you decide later.</p>
                <div class="mb-3 col-sm-12 billing_options">
                    <div class="billing_options-inner">
                        <label for="bill-insurer" aria-label=" Bill the participant's individual health insurance plan for the vaccine or service Participants don't need to subscribe to your organization's insurance plan. 1 of 4 ">
                            <span class="form-label">Bill the participant's individual health insurance plan for the vaccine or service</span>
                            <p><small>Participants don't need to subscribe to your organization's insurance plan.</small></p>
                        </label>                        
                        <input
                        class="form-check-input" 
                            type="checkbox"
                            formControlName="aci_billyourparticipantsinsurers"
                            id="bill-company-directly"
                            value="totalInvoiceForAll"
                            (change)="onSelectingFirstQue($event)"
                            name="billParticipants"
                            id="bill-insurer"
                            >
                    </div>

                 <div
                    *ngIf="isFirstQueSelected || checkIfFirstCheckboxIsAlreadyChecked()"
                    class="mb-2 mx-5" role="radiogroup"
                  >
                    <div class="d-flex align-items-center">
                      <label for="aci_employeesofthe" class="form-label"
                        >Do participants all share the same health plan? </label>
                    
                    </div>
        
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        formControlName="aci_employeesofthe"
                        type="radio"
                        id="health-plan"
                        value="805170000"
                        name="aci_employeesofthe"
                        aria-label="Do participants all share the same health plan?,Same health plan"
                      />
                      <label class="form-check-label" for="health-plan" aria-label="Do participants all share the same health plan? - Yes">
                       Yes
                      </label>
                    </div>
        
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        formControlName="aci_employeesofthe"
                        type="radio"
                        id="differ-plan"
                        value="805170001"
                        name="aci_employeesofthe"
                        aria-label="Differing health plans"
                        tabindex="0"
                        aria-describedby="error_aciHealthPlan"
                      />
                      <label class="form-check-label" for="differ-plan" aria-label="Do participants all share the same health plan? - No">
                        No
                      </label>
                    </div>
                    <span class="error-msg" role="alert" aria-live="assertive" id="error_aciHealthPlan"
                      *ngIf="(aciHealthPlan?.dirty || aciHealthPlan?.touched) && aciHealthPlan?.errors?.required"
                      role="alert" >
                      Please select one of the options above.
                    </span>
                  </div> 

                
                    
                       
                   <div
                        *ngIf="isFirstQueSelected || checkIfFirstCheckboxIsAlreadyChecked()"
                        class="mb-2 ms-5"
                      > 
                            <label class="form-label" >Please list health plans for us to check coverage</label>
                            <textarea class="form-control mb-2" rows="4" style="resize: none;"
                            formControlName="aci_insurancename"
                            autocomplete="new-aci_insurancename"
                            type="text"
                            class="form-control input-text"
                            id="aci_insurancename"
                            placeholder="Anthem, UnitedHealthcare, Medicare"
                            aria-label="Please list all insurers to be billed *"
                            (focus)="formFieldNames.aci_insurancename.noFocus=false" (focusout)="formFieldNames.aci_insurancename.noFocus=true"
                            [ngClass]="{'input-error': (aciInsuranceName?.dirty || aciInsuranceName?.touched) && aciInsuranceName?.errors?.required && formFieldNames.aci_insurancename.noFocus}"
                            [maxlength]="billingControls['aci_insurancename']['length']"
                             name="textareaInput" placeholder="Anthem, UnitedHealthcare, Medicare, etc." aria-describedby="error_aciInsuranceName" tabindex="0"></textarea>
                            <!-- <span class="error-msg" *ngIf="!ti.valid && ti.touched"><i class="bi bi-exclamation-circle-fill me-2"></i>Please share your answer</span> -->
                            
                          <span class="error-msg"   role="alert" aria-live="assertive" id="error_aciInsuranceName"
                            *ngIf="(aciInsuranceName?.dirty || aciInsuranceName?.touched) && aciInsuranceName?.errors?.required && formFieldNames.aci_insurancename.noFocus" 
                            role="alert">
                            Please enter the name of at least one insurer.
                          </span>
                          <hr>
                        </div> 
                       
                      
                      
                 
                       
                        <div
                        *ngIf="isFirstQueSelected || checkIfFirstCheckboxIsAlreadyChecked()"
                        class="mb-2 mx-5" role="radiogroup"
                      >
                        <label class="form-label" >If an insurance claim is denied, whom should we bill?</label>
                        <div class="form-check mb-2">
                            <input type="radio" class="form-check-input me-2"  
                            formControlName="aci_responsibleforreimbursementtothepharmacy"
                            type="radio"
                            id="organization"
                            value="805170000"
                            name="aci_responsibleforreimbursementtothepharmacy" tabindex="0"  aria-describedby="error_aciReimbursmentOption"
                           >
                            <label class="custom-control-label" for="organization"  aria-label="If an insurance claim is denied, whom should we bill? Your organization">Your organization</label>
                        </div>
                        <div class="form-check mb-3">
                            <input type="radio" class="form-check-input me-2"
                            formControlName="aci_responsibleforreimbursementtothepharmacy"
                            type="radio"
                            id="participants"
                            value="805170001"
                            name="aci_responsibleforreimbursementtothepharmacy"
                           tabindex="0"
                           aria-describedby="error_aciReimbursmentOption"
                            >
                            <label class="custom-control-label" for="participants"  aria-label="If an insurance claim is denied, whom should we bill? Participants">Participants</label>
                        </div>
                        <span class="error-msg"   role="alert" aria-live="assertive" id="error_aciReimbursmentOption"
                        *ngIf="(aciReimbursmentOption?.dirty || aciReimbursmentOption?.touched) && aciReimbursmentOption?.errors?.required"
                        role="alert" >
                        Please select one of the options above.
                      </span>
                    </div>                   
                    
                </div>
                <div class="mb-3 col-sm-12 billing_options">
                    <div class="billing_options-inner">
                        <label for="collect-participants" aria-label="Charge participants at the clinic We can charge each participant at the time of service. 2 of 4">
                            <span class="form-label">Charge participants at the clinic</span>
                            <p><small>We can charge each participant at the time of service.</small></p>
                        </label>
                        <input type="checkbox" class="form-check-input" 
                        formControlName="aci_collectpaymentfromparticipants"
                        type="checkbox"
                        id="collect-participants"
                        value="totalInvoiceForEach"
                        tabindex="0"
                        (change)="onSelectingSecondQue($event)"
                        
                        >
                    </div>
                </div>
                <div class="mb-3 col-sm-12 billing_options">
                    <div class="billing_options-inner">
                        <label for="bill-company" aria-label="Invoice your company directly We can invoice your organization for all services provided. 3 of 4 ">
                            <span class="form-label">Invoice your company directly</span>
                            <p><small>We can invoice your organization for all services provided.</small></p>
                        </label>
                        <input type="checkbox" class="form-check-input" id="bill-company" 
                        formControlName="aci_billyourcompanydirectly"
                        type="checkbox"
                        value="totalInvoiceForEach"
                        tabindex="0"
                        (change)="onSelectingThirdQue($event)"
                       
                        >
                    </div>
                </div>
                <div class="mb-3 col-sm-12 billing_options">
                    <div class="billing_options-inner">
                        <label for="split-participants" aria-label="I don't know No worries! We will reach out to you directly and help you make the right choice for your clinic and participants. 4 of 4">
                            <span class="form-label">I don't know</span>
                            <p><small>No worries! We will reach out to you directly and help you make the right choice for your clinic and participants.</small></p>
                        </label>
                        <input type="checkbox" class="form-check-input" 
                        formControlName="aci_split_costwithparticipants"
                        type="checkbox"
                        id="split-participants"
                        tabindex="0"
                        value="totalInvoiceForEach"
                        (change)="onSelectingFourthQue($event)"
                        
                        >
                    </div>
                </div>

                <span class="error-msg pos"   role="alert" aria-live="assertive" id="error_generic"
                *ngIf="showGenericErrorMessage()"
                role="alert" >
                Please select one or more of the options above.
              </span>
           
                
              <div class="col-sm-12 mt-5">
                <button type="button" (focus)='onPreviousButtonFocus()' tabindex="{{previuosButtonTabIndex}}"
                *ngIf="showPreviousbtn" class="btn btn-lg btn-outline-secondary rounded-pill px-4 me-md-3" 
          (click)="navigateBack()">Previous</button>
          <button type="submit"   (focus)='onNextButtonFocus()' tabindex="0" 
          [ngClass]="billingForm.invalid || !showNextButton()? 'disabled-clickable' : '1'"
          [disabled]="loading"
          [attr.aria-label]="billingForm.invalid || !showNextButton() ?'Next button is dimmed':AriaTextSubmitBtn"
          aria-describedby="error_generic"
          (click)="navigateNext()"
          class="btn btn-lgbill btn-primary rounded-pill px-4 me-md-3"
          >{{nextBtnText}}</button>
              </div>
            <!-- <span class="error-msg" role="alert" *ngIf="isBillingOptionsTouchedAndInvalid && !isBillingOptionsSelected">
                Please select one or more of the options above.
                </span> -->
        </div>
      </div>
       
        <!-- <div class="row footer shadow">
           
            <div class="col-lg-10 py-3 text-end d-flex justify-content-end d-md-block">
                
            </div>
        </div> -->
    </div>
</form>